import { createFileRoute, Outlet } from '@tanstack/react-router';

import { DashboardLayout } from '@/components/layoutAndProvidersWrapper/DashboardLayout.tsx';
import { LandingPageProvider } from '@/pages/landingPage/LandingPageProvider';

// Dashboard layout route group: no padding
// This layout wraps all routes in the (dashboard) group
export const Route = createFileRoute('/(dashboard)')({
  component: () => {
    return (
      <DashboardLayout>
        <LandingPageProvider>
          <Outlet />
        </LandingPageProvider>
      </DashboardLayout>
    );
  },
});
